import { formatCurrencyV2 } from '@wix/domains-serverless-interface';
const currencySettingsDefault = {
  code: 'USD',
  decimalSeparator: '.',
  groupSeparator: ',',
  minorUnits: 2,
  negativePrefix: '- ¤',
  negativeSuffix: '',
  positivePrefix: '¤',
  positiveSuffix: '',
  symbol: '&#36;'
};
export const isInteractiveClickTarget = target => target instanceof Element && Boolean(target.closest('a, button, [role="button"], [role="link"]'));
export const formatPrice = _ref => {
  let {
    amount,
    currencySettings = currencySettingsDefault
  } = _ref;
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(numAmount)) {
    return '$0.00';
  }
  const formatter = formatCurrencyV2(String(numAmount), currencySettings);
  return formatter;
};
//# sourceMappingURL=utils.js.map